'use client'

import { useAuth } from '@/providers/AuthProvider'
import { routes } from '@/utils/routes'
import { AppBar, Avatar, Box, Container, IconButton, Toolbar, Typography } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Image from 'next/image'
import { default as RouterLink } from 'next/link'
import { usePathname } from 'next/navigation'
import * as React from 'react'
import { EventSearch } from './inputs/event-search'

export const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const { user, logout } = useAuth()
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null)
  const pathname = usePathname()

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const linkStyle = React.useCallback(
    (pageName: string) => {
      return {
        textDecoration: 'none',
        color: pathname?.includes(pageName) ? '#333F48' : '#5D7383',
        fontWeight: pathname?.includes(pageName) ? 700 : 500,
        marginRight: 50,
        borderBottom: pathname?.includes(pageName) ? '2px solid #3E66FB' : 'none',
        paddingBottom: 5,
      }
    },
    [pathname],
  )

  return (
    <>
      {/* App Bar */}
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          position="fixed"
          sx={{ margin: 0, borderRadius: 0, boxShadow: 'none' }}
          color="inherit"
        >
          <Container maxWidth="xl">
            <Toolbar sx={{ justifyContent: 'space-between' }}>
              <RouterLink
                href={routes.home}
                style={{
                  textDecoration: 'none',
                  color: '#fff',
                  marginLeft: 10,
                }}
              >
                <Image width={50} height={50} src="/assets/logo.png" alt="Logo" />
              </RouterLink>
              <Box display="flex" width="100%" px={9}>
                <RouterLink href={routes.adminCalendar} style={linkStyle('calendar')}>
                  Naptár
                </RouterLink>
                <RouterLink href={routes.adminCreateEvent} style={linkStyle('create-event')}>
                  Új esemény létrehozása
                </RouterLink>
                <RouterLink href={routes.adminSettings} style={linkStyle('settings')}>
                  Beállítások
                </RouterLink>
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Box sx={{ maxWidth: 250, paddingRight: 4 }}>
                  <EventSearch />
                </Box>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, mr: 1 }}>
                  <Avatar sx={{ bgcolor: '#24e0bc' }}>
                    {user?.email?.[0]?.toUpperCase() ?? null}
                  </Avatar>
                </IconButton>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      </Box>

      {/* Avatar dropdown */}
      <Menu
        sx={{ mt: 4 }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
        PaperProps={{ sx: { borderRadius: '8px' } }}
      >
        <MenuItem
          onClick={() => {
            logout()
          }}
        >
          <Typography textAlign="center">Kijelentkezés</Typography>
        </MenuItem>
      </Menu>

      {/* Content */}
      <Box mt={12.5}>{children}</Box>
    </>
  )
}
